import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import AdminStoreProductsList from './AdminStoreProductsList'
import { connect } from 'react-redux'
import {useNavigate} from 'react-router-dom'
import axios from 'axios'
import AdminStoreProductKPIs from './AdminStoreProductKPIs'
import SearchComponent from '../../../../Search'
import { useLocation } from 'react-router-dom'
const AdminStoreProducts = (props) => {

    const location = useLocation()
    const { state } = location
    const storeId = state.store
    const userId = state.userId
    const store_name = state.store_name
    const [SearchQuery, setSearchQuery] = useState("")
    const [PageSize, setPageSize] = useState(10)
    const [TotalPages, setTotalPages] = useState(1)
    const [KPIsData, setKPIsData] = useState([])
    const [LoadingVisibility, setLoadingVisibility] = useState("none")
    const [dataVisibility, setDataVisibility] = useState("block")
    const [NextLink, setNextLink] = useState("")
    const [ProductList, setProductList] = useState([])
    const [TotalProducts, setTotalProducts] = useState(0)
    const [PageLimit, setPageLimit] = useState(1)
    const [StatusFilters, setStatusFilters] = useState({status:'Buyable'})
    const [OrderBy, setOrderBy] = useState("title")
    
    const numberFormatter = new Intl.NumberFormat('en-ZA', {
        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    })
    const LoadProductsData = async () => {
        const config = {
            headers: {
                'Content-Type' : 'application/json',
                'Accept' : 'application/json',
                'Authorization' : `JWT ${localStorage.getItem('access')}`
            }
        }
        const Body = JSON.stringify({
            "account" : userId,
            "dashboard" : storeId
        })
        try { 
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/productKPIs/`, Body,config)
            setKPIsData(response.data['productData'])
          // setNextLink(response.data['next'])
        } catch (error) {
          // console.log('first', error)
        }
    }
    
    
    const loadProductList = async(page_number, filter, orderBy, store, accountId, searchQuery, pageSize) => {
        const config = {
            headers: {
                'Content-Type' : 'application/json',
                'Accept' : 'application/json',
                'Authorization' : `JWT ${localStorage.getItem('access')}`
            }
        }
        const Body = JSON.stringify({
            "account" : accountId,
            "page_number" : page_number,
            "dashboard" : store,
            "filters" :  filter,
            "order_by" : orderBy,
            "search_query" : searchQuery,
            "page_size" : pageSize
        })
        try {
            const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/admin/productList/`, Body,config)
            setProductList(response.data['results'])
            setTotalPages(response.data['total_pages'])
            setTotalProducts(response.data['total_records'])  
            setPageLimit(response.data['pagelimit'])
            // setNextLink(response.data['next'])
        } catch (error) {
          // console.log('first', error)
        }
    }

    const onOrderByChange = (e, orderBy) => {
        e.preventDefault()
        setTotalProducts(0)
        setOrderBy(orderBy)
        loadProductList(1, StatusFilters, orderBy, storeId, userId)    
    }
    const formatter = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
    
        // These options are needed to round to whole numbers if that's what you want.
        minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    })
    
    
    const onPageSizeChange = (e) => {
        setTotalProducts(0)
        setPageSize(e.target.value)
        loadProductList(1, StatusFilters, OrderBy, storeId, userId, SearchQuery, e.target.value)    
    }

    
    const onSearchInputChange = (e) => {
        e.preventDefault()
        setTotalProducts(0)
        setSearchQuery(e.target.value)
        loadProductList(1, StatusFilters, OrderBy, storeId, userId, e.target.value, PageSize)    
    }
    
    
    
    const onStatusFilterChange = (e) => {
        setTotalProducts(0)    
        setStatusFilters({...StatusFilters, [e.target.name]: e.target.value})  
        loadProductList(1, {[e.target.name]: e.target.value}, OrderBy, storeId, userId, SearchQuery, PageSize)
    }

    useEffect(() => {
        LoadProductsData()
        loadProductList(1, StatusFilters, OrderBy, storeId, userId, SearchQuery, PageSize)
    
    }, [])
    const navigate = useNavigate()
    if (process.env.REACT_APP_STORE_NAME != "CI Mart"){
        navigate("/")
    }
    return (
        <>
            <Helmet>				
				<title>{store_name} Products</title>
                <meta
                    name="description"
                    content={`${store_name} Products`}
                />
            </Helmet>
            <div style={{display: LoadingVisibility}}>
                <div id="global-loader" >
                    <div className="whirly-loader"> </div>
                </div>
            </div>
            <div className="content">
                <div style={{display: dataVisibility}}>
                    
                    <AdminStoreProductKPIs
                        numberFormatter={numberFormatter}
                        currencyFormatter={formatter}
                        KPIsData={KPIsData}
                    />
                    <SearchComponent
                        placeholder={"Product Name / SKU / Offer ID"}
                        SearchQuery={SearchQuery}
                        onSearchInputChange={onSearchInputChange}
                    />
                    <hr/>
                    <AdminStoreProductsList
                        dashboardId = {storeId}
                        PageSize={PageSize}
                        onPageSizeChange={onPageSizeChange}
                        onStatusFilterChange={onStatusFilterChange}
                        ProductList={ProductList}
                        TotalProducts={TotalProducts}
                        formatter={formatter}
                        numberFormatter={numberFormatter}
                        TotalPages={TotalPages}
                        onLoadProductList={loadProductList}
                        OrderBy={OrderBy}
                        StatusFilters={StatusFilters}
                        SearchQuery={SearchQuery}
                    />
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
	isAuthenticated: state.Auth.isAuthenticated,
	user: state.Auth.user,
})

export default connect(mapStateToProps ,{})(AdminStoreProducts)